module.exports = __webpack_public_path__ + "img/empty.c8c961f2.png";